export enum TeacherDialogIds {
    CalendarConnection = 'calendar-connection',
    AudioRecordingConsent = 'audio-recording-consent',
    DeTeachersDemoClassReminder = 'de-teachers-demo-class-reminder',
}

export interface TeacherDialogProps {
    [key: string]: unknown;
}

export interface TeacherDialogBaseProps {
    hideDialog: () => void;
}

export interface TeacherDialog {
    id: TeacherDialogIds;
    props?: TeacherDialogProps;
}
